import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  public isStaffHeaderVisible: BehaviorSubject<boolean> = new BehaviorSubject(true);

  constructor() { }

  showStaffHeader(): void {
    this.isStaffHeaderVisible.next(true);
  }

  hideStaffHeader(): void {
    this.isStaffHeaderVisible.next(false);
  }
}
